import { connect } from "react-redux";
import { IconButton, Box, Typography, Stack } from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { toggleTheme } from "../app/features/theme/themeSlice";

function ThemeToggleButton({ themeMode, onToggleTheme }) {
  const isDark = themeMode === "dark";

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 16,
        left: 16,
        zIndex: 1000,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={0.5}
        onClick={onToggleTheme}
        sx={{
          bgcolor: "rgba(0, 0, 0, 0)",
          borderRadius: 2,
          pr: 1,
          cursor: "pointer",
          transition: "transform 0.2s ease",
          "&:hover": {
            transform: "scale(1.05)",
          },
        }}
      >
        <IconButton
          aria-label="toggle theme"
          sx={{
            color: "text.primary",
            pointerEvents: "none",
          }}
        >
          {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
        <Typography
          variant="caption"
          sx={{
            color: "text.primary",
            fontSize: "0.7rem",
            userSelect: "none",
          }}
        >
          {isDark ? "Switch to Light?" : "Switch to Dark?"}
        </Typography>
      </Stack>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  themeMode: state.theme.mode,
});

const mapDispatchToProps = (dispatch) => ({
  onToggleTheme: () => dispatch(toggleTheme()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemeToggleButton);
